import "./Operations.css";

const Operations = () => {
  return (
    <div>


      <div className="hero_img operation_mobile_img">
      <img src="/assets/operation_banner.jpg" alt="" />

      <div className="hero_title">
        Providing excellent service <br /> in Network Infrastructure
      </div>
      </div>
      <div className="container2">
        <div className="operationpg_div1">
          <h2>What We Do</h2>
          <p>
            As one of the leading Passive-Digital Connectivity Infrastructure
            Providers (DCIP) in the country, we assist all major telecom
            companies through a diverse range of built-to-suit solutions. Our
            area of expertise lies in the hyper-growing Data & Digitization
            sector where we operate shared In-Building Communications
            infrastructure for wireless carriers, broadcasters, and other
            companies that provide end-user communication services.
          </p>
        </div>
        <div className="portp_div2 container">
          <div className="portp_div21  ">
            <h2>Environment</h2>
            <p>
              Crest Digitel recognizes its responsibility to protect the
              environment and is committed to regulating all its activities for
              minimizing adverse environmental impacts arising from its
              operations. All the Crest sites are diesel-free. We also make sure
              that electronic waste and batteries are disposed in accordance
              with hazardous waste management rules.
            </p>
            <p>
              Given the energy-intensive nature of the telecom sector, we have
              consistently strived to remain at the forefront of developing a
              Sustainable Digital Infrastructure through our comprehensive
              offerings, operational expertise and top-notch human capital.
            </p>
            <p>
              We strive to operate in an inclusive environment where we can
              support the communities we serve, the environment in which we have
              an impact and our employees’ overall well-being.
            </p>
          </div>
          <div className="portp_div31">
            <img src="/assets/operations/operationimg2.jpg" alt="" />
          </div>
        </div>

        <div className="portp_div2 container op_flex">
          <div className="portp_div31">
            <img src="/assets/operations/operationimg3.jpg" alt="" />
          </div>
          <div className="portp_div21  ">
            <h2>Safety</h2>
            <p>
              Crest Digitel recognizes its responsibility to provide a safe and
              healthy working environment to all its employees, workers,
              partners and stakeholders. We are working to have best-in-class
              Health, Safety, Security & Environment practices at all our sites,
              workplaces, warehouses and offices. We firmly believe that all
              accidents, occupational illnesses, injuries, safety &
              environmental incidents are preventable. The fundamental
              responsibility of implementing the system and continual
              improvement lies with all of us, particularly site management. Our
              Seven Safety habits enable all to strictly follow and implement
              Health & Safety Management System uniformly at all Sites,
              Workplaces and Offices covering our employees, workers,
              stakeholders, customers, visitors and business partners against
              any risk, hazard, injury or ill health and require a mandatory
              site visit to check the safety compliance.
            </p>
          </div>
        </div>

        <div className="portp_div2 container">
          <div className="portp_div21  ">
            <h2>Service</h2>
            <p>
              We at Crest are committed to providing a complete, cohesive
              customer experience that aligns with our organization’s vision of
              Enabling connections for life. Our offerings help efficiently
              enable voice & data connectivity in hyperdense locations including
              residential, commercial, retail, travel and industrial areas as
              per the customer requirements by providing scalability at a low
              operational cost and negating the need for upfront Capex to be
              incurred by the customers. We are committed to revolutionizing
              people’s lives by seamlessly connecting them at any time and from
              any location. This commitment is evidenced by maintaining an
              excellent uptime in line with customers’ expectations.
            </p>
          </div>
          <div className="portp_div31">
            <img src="/assets/operations/operationimg4.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Operations;
